import { render, staticRenderFns } from "./pricing-list.page.vue?vue&type=template&id=a2599f98&"
import script from "./pricing-list.page.vue?vue&type=script&lang=js&"
export * from "./pricing-list.page.vue?vue&type=script&lang=js&"
import style0 from "./pricing-list.page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports